import React from 'react';
import Plot from 'react-plotly.js';
import NWS_OFFICE_LOCATIONS from '../lib/nwsOfficeLocations';

// Use all offices — Plotly's albers usa projection handles AK/HI as insets
const allOffices = NWS_OFFICE_LOCATIONS;

const OfficeMapSVG = ({ onOfficeClick, theme }) => {
  const lats = allOffices.map(o => o.lat);
  const lons = allOffices.map(o => o.lon);
  const texts = allOffices.map(o => `<b>${o.id}</b> — ${o.name}`);
  const ids = allOffices.map(o => o.id);

  return (
    <Plot
      data={[{
        type: 'scattergeo',
        locationmode: 'USA-states',
        lat: lats,
        lon: lons,
        text: texts,
        hoverinfo: 'text',
        marker: {
          size: 8,
          color: '#0d6efd',
          line: { color: '#fff', width: 1 },
        },
        customdata: ids,
      }]}
      layout={{
        geo: {
          scope: 'usa',
          projection: { type: 'albers usa' },
          showlakes: false,
          bgcolor: theme === 'dark' ? '#1a1a2e' : '#f8fafc',
          landcolor: theme === 'dark' ? '#2a2a4a' : '#e8edf2',
          subunitcolor: theme === 'dark' ? '#555' : '#aab',
          countrycolor: theme === 'dark' ? '#666' : '#999',
        },
        paper_bgcolor: theme === 'dark' ? '#1a1a2e' : '#ffffff',
        plot_bgcolor: theme === 'dark' ? '#1a1a2e' : '#ffffff',
        margin: { l: 0, r: 0, t: 30, b: 0 },
        dragmode: false,
        autosize: true,
        title: {
          text: 'Select an NWS weather forecast office to view weather story',
          font: { size: 13, color: theme === 'dark' ? '#aaa' : '#666' },
          x: 0.5,
          xanchor: 'center',
        },
      }}
      style={{ width: '100%', height: '100%' }}
      useResizeHandler={true}
      config={{ displayModeBar: false, responsive: true, topojsonURL: process.env.PUBLIC_URL + '/' }}
      onClick={(data) => {
        if (data.points?.[0]) {
          const idx = data.points[0].pointIndex;
          const office = allOffices[idx];
          if (office) onOfficeClick(office);
        }
      }}
    />
  );
};

export default OfficeMapSVG;
